export default {
  app: {
    Host: "http://rtaf.live",
    Thumb: "http://10.107.0.55:8080/upload",
    Thumbor: "http://rtaf.live",
    ThumborUse: true 
    // Host: "https://rtaf3-core-api-web.i-iptv.com",
    // Thumb: "https://rtaf3-core-system.i-iptv.com/upload",
    // Thumbor: "https://thumbor.i-iptv.com",
    // ThumborUse: true
  }
};
